module.exports = __webpack_public_path__ + "img/moon2.c33226ab.svg";